module.exports = __webpack_public_path__ + "media/images/home/main/aa/14-87817d945fd7912232314ee7b38e835a.png";